import { useSearchParams } from 'react-router-dom'
import { compact } from 'lodash'
import { useEffect, useMemo } from 'react'
import { MarketingContactTable } from './MarketingContactTable'
import { PredefinedFilter } from 'app/filter.utils'

export default function MonthlyStaffBreakdownTable({
  staffName,
  staffId,
  fromDate,
  toDate,
  channel,
  title,
  onClose,
  defaultFilters,
}: {
  staffName: string
  staffId?: string
  fromDate: string
  toDate: string
  channel: string
  title: string
  onClose: () => void
  defaultFilters?: PredefinedFilter
}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const locationIds = useMemo(() => compact(searchParams.get(`locationIds`)?.split(`,`) ?? []), [searchParams])

  useEffect(() => {
    setSearchParams((prev) => {
      prev.set(`details`, staffName)
      return prev
    })

    return () => {
      setSearchParams((prev) => {
        prev.delete(`details`)
        prev.delete(`filters`)
        return prev
      })
    }
  }, [])

  return (
    <MarketingContactTable
      channel={channel}
      title={title}
      filterContactsBy="Staff"
      fromDate={fromDate}
      toDate={toDate}
      locationIds={locationIds}
      leadOwner={{ name: staffName === `Unassigned` ? `` : staffName }}
      leadOwnerId={staffId}
      showDisqualified={false}
      platform={searchParams.get(`platform`) ?? ``}
      onClose={onClose}
      defaultFilters={defaultFilters}
    />
  )
}
